// Display order + labels for the blog sub-nav's "Cities" menu. Cities aren't a
// post field yet, so each entry just points at the matching tag archive
// (`/blog/category/[slug]`). This list is a filter, never a source of routes:
// only cities a post actually tags get rendered, because an archive with no
// posts is an indexable soft 404.
export const BLOG_CITIES: { name: string; slug: string }[] = [
  { name: "Miami", slug: "miami" },
  { name: "New York", slug: "new-york" },
  { name: "Los Angeles", slug: "los-angeles" },
  { name: "Chicago", slug: "chicago" },
  { name: "Houston", slug: "houston" },
  { name: "San Francisco", slug: "san-francisco" },
  { name: "Seattle", slug: "seattle" },
];
